/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type GlobalMailSettingsType from '@jira/spa-apps__admin-pages-global-mail-settings/src/GlobalMailSettingsType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyGlobalMailSettings: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof GlobalMailSettingsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-global-mail-settings", jiraSpaEntry: "async-global-mail-settings" */ '@jira/spa-apps__admin-pages-global-mail-settings/src/GlobalMailSettingsType.tsx'
		),
	),
);

const AsyncGlobalMailSettings = (): React.JSX.Element => (
	<LazyPage Page={LazyGlobalMailSettings} pageId="global-mail-settings" shouldShowSpinner={false} />
);

export default AsyncGlobalMailSettings;
